import { showPasswordToggler } from '../../../__assets__/scripts/show-password-button'
import { handleForm } from '../../../__assets__/scripts/input-form'
import { animateCounters } from '../../../__assets__/scripts/component/counter-up'
import { initTabSwitching } from '../../../__assets__/scripts/component/tab-switch'
import Glide from '../../../__assets__/scripts/vendor/glidejs'
import { spawnTrackingEventListners } from '../../../../assets/scripts/components/tracking-ga-events'
import cookieConsent from 'services/cookies-consent'
init()

function init(): void {
  // Add show password behavior
  showPasswordToggler()

  // Registry Form
  handleForm()

  // Init glide slider
  const glide = new Glide('.glide', {
    type: 'carousel',
    perView: 1,
    focusAt: 'center',
  })
  glide.mount()

  // Animate counters
  animateCounters()

  // Init tab buttons and switching
  initTabSwitching()

  spawnTrackingEventListners()

  // cookiebot banner
  cookieConsent.init()
}
